import * as React from 'react';
/**
 * The Navigation context shares details about the months being navigated in DayPicker.
 *
 * Access this context from the [[useNavigation]] hook.
 */
export var NavigationContext = React.createContext(undefined);
//# sourceMappingURL=NavigationContext.js.map